import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    variants: {
        reverse: {
            true: {
                wrapper: 'order-first lg:order-last',
            },
        },
        orientation: {
            vertical: {
                headline: 'justify-start lg:justify-center',
                title: 'text-start lg:text-center lg:max-w-xl lg:mx-auto',
                description: 'text-start lg:text-center lg:max-w-2xl lg:mx-auto',
            },
        },
    },
} satisfies TVConfig<typeof ui>['pageSection'];
